exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  font-family: 'Courgette', cursive; }\n\n.headerUnderline {\n  width: 30%;\n  height: 1rem;\n  background-color: #f39c12; }\n\n@media only screen and (max-width: 991px) {\n  .headerUnderline {\n    width: 100%; } }\n\n.imageGalleryWrapper {\n  text-align: center; }\n\nngx-gallery {\n  display: inline-block; }\n\n/* make keyframes that tell the start state and the end state of our object */\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.fade-in {\n  opacity: 0;\n  /* make things invisible upon start */\n  -webkit-animation: fadeIn ease-in 1;\n  /* call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time */\n  animation: fadeIn ease-in 1;\n  -webkit-animation-fill-mode: forwards;\n  /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/\n  animation-fill-mode: forwards;\n  -webkit-animation-duration: 1.5s;\n  animation-duration: 1.5s; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Jeremy/Desktop/EFA/jerusalem-temple/src/app/gallery/gallery.component.scss
// module id = ../../../../../src/app/gallery/gallery.component.scss
// module chunks = main